<script>
import { Line, mixins } from 'vue-chartjs'
import { stringify } from 'flatted';

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    customOptions: {
        type: Object,
        default() {
            return {
                valuePrepend: '',
                year: '',
             }
         },
    },
    options: {
      type: Object,
    }
  },
  data() {
      return {
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          fullMonths: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      }
  },
  mounted () {
    this.renderChart(this.chartData, this.dynamicOptions);
  },
  computed: {
      dynamicOptions() {
          const customOptions = this.customOptions;
          const vm = this;
          return {
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                  display: false
              },
              scales: {
                  yAxes: [
                      {
                          gridLines: {
                              //display: false,
                              //drawOnChartArea: false,
                              drawBorder: false
                          },
                          ticks: {
                              beginAtZero: true,
                              callback: function (value) { if (Number.isInteger(value)) { return (customOptions.valuePrepend?customOptions.valuePrepend:'') + value } },
                              //stepSize: 1
                          }
                      }
                  ],
                  xAxes: [
                      {
                          ticks: {
                              //display: false,
                          },
                          gridLines: {
                              display: false,
                              drawOnChartArea: false,
                              drawBorder: false
                          }
                      }
                  ]
              },
              tooltips: {
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                borderColor: '#628aba',
                borderWidth: 1,
                xPadding: 15,
                yPadding: 12,
                titleFontColor: "#333",
                titleSpacing: 4,
                bodyFontColor: "#333",
                displayColors: false,
                
                callbacks: {
                    title: function(tooltipItem, data) {
                        var title = tooltipItem[0].xLabel;
                        if (vm.shortMonths.indexOf(title)!==-1) {
                            return vm.fullMonths[vm.shortMonths.indexOf(title)] + ' ' + customOptions.year;
                        } else return null;
                    },
                    label: function(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label || '';
                        if (label) {
                            label += ': ' + (customOptions.valuePrepend?customOptions.valuePrepend:'');
                        }
                        label += tooltipItem.yLabel;
                        return label;
                    }
                }
             }
           }
       },
  }
}
</script>